import { useState, useEffect, useCallback } from 'react';
import { AuthUser } from '../types';
import {
  isAuthenticated,
  getUserFromToken,
  loginWithMicrosoft,
  logout as authLogout,
  handleCallback,
} from '../services/auth';

export function useAuth() {
  const [user, setUser] = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadUser = useCallback(() => {
    if (isAuthenticated()) {
      const u = getUserFromToken();
      setUser(u);
    } else {
      setUser(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  const login = useCallback(async () => {
    try {
      await loginWithMicrosoft();
    } catch (err) {
      setError('Error al iniciar sesión');
      console.error(err);
    }
  }, []);

  const processCallback = useCallback(async (code: string, state: string) => {
    try {
      setLoading(true);
      await handleCallback(code, state);
      loadUser();
    } catch (err) {
      setError('Error al procesar el inicio de sesión');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [loadUser]);

  const logout = useCallback(() => {
    authLogout();
    setUser(null);
  }, []);

  return {
    user,
    loading,
    error,
    isAuthenticated: !!user,
    login,
    logout,
    processCallback,
  };
}
